import { runtimeEnv } from '../types/runtimeEnv';

/**
 * Link ins Anwenderhandbuch (docs/handbuecher/INTERMAL-ANWENDER.md), das
 * manuell ins Plattform-Wiki eingefuegt wird (Paket 8). Die Seiten-URL kommt
 * zur Laufzeit aus env.js (`HANDBUCH_URL`, gerendert von
 * intermal/Dockerfile.frontend); fuer `pnpm start` geht ersatzweise
 * `REACT_APP_HANDBUCH_URL`.
 *
 * Gibt `null` zurueck, solange keine http(s)-URL konfiguriert ist, damit die
 * Oberflaeche keinen toten Hilfe-Link zeigt. Mit `anker` wird der stabile
 * HTML-Anker des Handbuchs angehaengt (z. B. `rechnungen`, `erster-tag`);
 * ein in der Konfiguration schon enthaltenes `#...` wird dabei verworfen.
 */
export function handbuchUrl(anker?: string): string | null {
  const roh = (runtimeEnv().HANDBUCH_URL || process.env.REACT_APP_HANDBUCH_URL || '').trim();
  const basis = roh.split('#')[0].trim();
  if (!/^https?:\/\/[^/\s]+/i.test(basis)) return null;
  const ziel = anker?.trim().replace(/^#/, '');
  return ziel ? `${basis}#${ziel}` : basis;
}
